/** Parse `value` for MUI (`Date | null`). Supports `YYYY-MM-DD` strings and `Date`. */
export function toPickerDate(value: string | Date | null | undefined): Date | null {
  if (value == null || value === '') return null;
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  const isoDate = /^(\d{4})-(\d{2})-(\d{2})/.exec(value);
  if (isoDate) {
    const [, year, month, day] = isoDate;
    return new Date(Number(year), Number(month) - 1, Number(day));
  }

  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

/** Format as `YYYY-MM-DD` for string-mode consumers. */
export function toPickerString(date: Date | null): string | null {
  if (!date || Number.isNaN(date.getTime())) return null;
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function formatPickerChange(value: string, date: Date | null): string | null;
export function formatPickerChange(value: Date | null, date: Date | null): Date | null;
export function formatPickerChange(
  value: string | Date | null,
  date: Date | null
): string | Date | null {
  return typeof value === 'string' ? toPickerString(date) : date;
}
